import { usersMetaData } from '@/database'
import { createMetaData } from '@/database/usersMetaData'

import { sharedInstance as auth } from './AuthService'

import store from '@/store'

export default class UserMetaDataService
{
	private currentUserId: string = ''
	private metaData?: UserMetaData

	constructor()
	{
		auth.onSignedInAsObservable().subscribe(user => {
			this.initialize(user.uid)
		})

		auth.onSignedOutAsObservable().subscribe(user => {
			this.currentUserId = ''
			this.metaData = undefined
		})
	}

	get friendsInvited()
	{
		if (!this.metaData)
		{
			return 0
		}

		if (!this.metaData.invited)
		{
			return 0
		}

		return this.metaData.invited.length
	}

	get hasPro()
	{
		if (!this.metaData)
		{
			return false
		}

		if (!this.metaData.claims)
		{
			return false
		}

		return this.metaData.claims.indexOf('pro') >= 0
	}

	// NOTE: these max values do not update live
	// user would have to refresh to get new values if
	// their friend happens to join while they are using the app
	// that is probably fine? Of course, we could listen to the
	// database entry and update accordingly
	get maxImages()
	{
		if (!this.metaData)
		{
			return 5
		}

		return this.metaData.maxImages || 5
	}

	get maxImageSize()
	{
		const defaultSize = {
			width: 1024,
			height: 1024
		}

		if (!this.metaData)
		{
			return defaultSize
		}

		return this.metaData.maxImageSize || defaultSize
	}

	get maxAudio()
	{
		if (!this.metaData)
		{
			return 1
		}

		return this.metaData.maxAudio || 1
	}

	get maxAudioSize()
	{
		if (!this.metaData)
		{
			return 1000000
		}

		return this.metaData.maxAudioSize || 1000000
	}

	get maxLevels()
	{
		if (!this.metaData)
		{
			return 5
		}

		return this.metaData.maxLevels || 5
	}

	get maxScreens()
	{
		if (!this.metaData)
		{
			return 5
		}

		return this.metaData.maxScreens || 5
	}

	get maxElements()
	{
		if (!this.metaData)
		{
			return 5
		}

		return this.metaData.maxElements || 5
	}

	get maxProjects()
	{
		if (!this.metaData)
		{
			return 3
		}

		return this.metaData.maxProjects || 3
	}

	async initialize(userId: string)
	{
		this.currentUserId = userId

		return this.loadMetaData()
	}

	private async loadMetaData()
	{
		if (!this.currentUserId)
		{
			return
		}

		const snap = await usersMetaData.doc(this.currentUserId).get()

		if (!snap.exists)
		{
			// TODO: we need to make it
			this.metaData = await createMetaData()
		}
		else
		{
			this.metaData = snap.data() as UserMetaData
		}

		store.commit('userMetaData/setData', this.metaData)
	}
}

const sharedInstance = new UserMetaDataService()

export {
	sharedInstance
}
